
<template>
  <svg width="32" height="32" viewBox="0 0 24 24"><path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2m-7.2 2l1.2-1.2V4h4v8.8l1.2 1.2H8.8z" fill="currentColor"></path></svg>
</template>

<script>
export default {
  name: 'MdiPinOutline'
}
</script>